// @flow
import { useContext } from 'react';
import OrgsAvailableTypesContext from './OrgsAvailableTypesContext';


const useOrgsAvailableTypes = () => useContext(OrgsAvailableTypesContext);

export default useOrgsAvailableTypes;
